/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/label-has-associated-control */
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useForm, FormProvider, yup, yupResolver } from '@gvlab/react-form';

import { Alert, Button } from '@gvlab/react-ui/components';
import { OtpInput } from '@gvlab/react-ui/v2/OtpInput';

import { InputAdornment, IconButton, TextField } from '@gvlab/react-theme/mui';
import { Visibility, VisibilityOff } from '@gvlab/react-icons';

import { verifyPassword } from 'store/Auth/recoverSlice';

/**
 * Form Validation Schema
 */
const schema = yup.object().shape({
  email: yup.string().email('You must enter a valid email').required('You must enter an email'),
  password: yup
    .string()
    .required('Please enter your password.')
    .min(8, 'Password is too short - should be 8 chars minimum.')
    .max(30, 'Password is too long - should be 30 chars maximum.'),
  verify: yup
    .string()
    .required('Please enter your password.')
    .min(8, 'Password is too short - should be 8 chars minimum.')
    .max(30, 'Password is too long - should be 30 chars maximum.'),
});

const defaultValues = {
  email: '',
};

const Form2 = () => {
  const dispatch = useDispatch();
  const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showVerify, setShowVerify] = useState(false);

  const methods = useForm({
    mode: 'onChange',
    defaultValues,
    resolver: yupResolver(schema),
  });
  const {
    register,
    getValues,
    reset,
    trigger,
    setError,
    formState: { isValid, dirtyFields, errors },
  } = methods;

  const onSubmit = async (model) => {
    try {
      console.log('model', model);
      dispatch(verifyPassword({ ...model, passcode: otp }));
    } catch (err) {
      setLoading(false);
    }
  };

  return (
    <FormProvider {...methods}>
      <div className="mb-8 text-left">
        <p className="text-sm dark:text-gray-400 text-gray-400">Sign in to access your account</p>
      </div>
      <form
        onSubmit={methods.handleSubmit(onSubmit)}
        className="space-y-12 ng-untouched ng-pristine ng-valid"
      >
        <div className="space-y-4">
          <div>
            <TextField
              error={!!errors?.email}
              helperText={errors?.email?.message}
              label="Email address"
              margin="dense"
              fullWidth
              {...register('email')}
              className="w-full px-3 py-2 border rounded-md dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
            />
          </div>
          <div>
            <TextField
              label="Password"
              type="password"
              error={!!errors?.password}
              helperText={errors?.password?.message}
              variant="outlined"
              fullWidth
              margin="dense"
              InputProps={{
                type: showPassword ? 'text' : 'password',
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowPassword(!showPassword)} size="large">
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              required
              {...register('password')}
              className="w-full px-3 py-2 border rounded-md dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
            />
          </div>
          <div>
            <TextField
              label="Verify Password"
              type="password"
              error={!!errors?.verify}
              helperText={errors?.verify?.message}
              variant="outlined"
              fullWidth
              margin="dense"
              InputProps={{
                type: showVerify ? 'text' : 'password',
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={() => setShowVerify(!showVerify)} size="large">
                      {showVerify ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              required
              {...register('verify')}
              className="w-full px-3 py-2 border rounded-md dark:border-gray-700 dark:bg-gray-900 dark:text-gray-100"
            />
          </div>
          <div>
            <div className="container">
              <OtpInput
                value={otp}
                onChange={(newValue) => {
                  setOtp(newValue);
                }}
              />
            </div>
          </div>
        </div>
        <div className="space-y-2">
          <Button
            color="primary"
            disabled={!!dirtyFields || !isValid}
            progress={loading}
            size="large"
            variant="contained"
            type="submit"
            onClick={methods.handleSubmit(onSubmit)}
            className="w-full px-8 py-3 font-semibold rounded-md m-0"
          >
            Submit
          </Button>
          <div className="text-center mt-4">
            Return to the{' '}
            <a rel="noopener noreferrer" href="/auth/login" className="underline">
              Sign in
            </a>
            .
          </div>
        </div>
        {showAlert && (
          <Alert
            message={errors?.general?.message}
            onClose={() => {
              setShowAlert(false);
            }}
          />
        )}
      </form>
    </FormProvider>
  );
};

export default Form2;
